var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "teleport",
    { attrs: { to: "#modals" } },
    [
      _c("transition", _vm._g({}, _vm.$listeners), [
        _vm.isVisible
          ? _c(
              "div",
              {
                class: _vm.rootClasses,
                attrs: {
                  "data-qa": `modal-visible-${_vm.isVisible}:${_vm.effectiveDataQa}`,
                },
              },
              [
                _vm.hasBackdrop
                  ? _c("div", {
                      staticClass: "gfu-modal__backdrop",
                      on: { click: _vm.onActionClose },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  _vm.tag,
                  _vm._g(
                    _vm._b(
                      {
                        tag: "component",
                        class: ["gfu-modal__body", _vm.bodyClasses],
                        attrs: { tabindex: "0", "data-qa": "modal-box:Body" },
                      },
                      "component",
                      _vm.$attrs,
                      false
                    ),
                    _vm.$listeners
                  ),
                  [
                    _vm.hasNavigation
                      ? _c(
                          "div",
                          {
                            class: [
                              "gfu-modal__navigation",
                              _vm.navigationClasses,
                            ],
                          },
                          [
                            _vm.showActionBack
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "_flex _tc--accent _ai-c _jc-c _gap-1 _pa-0",
                                    attrs: {
                                      "data-qa": "modal-navigation-back",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onActionBack.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("base-icon", {
                                      attrs: { name: "angle-left", size: "lg" },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.Resources.Common.ModalBackButton
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showActionClose
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "_flex _tc--accent _ai-c _jc-c _gap-1 _ml-a",
                                    attrs: {
                                      "data-qa": "modal-navigation-close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.onActionClose.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.Resources.Common.ModalCloseButton
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("base-icon", {
                                      attrs: {
                                        name: "times",
                                        size: "lg",
                                        "data-qa": "modal-button:Close",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasTitle
                      ? _c(
                          "div",
                          {
                            staticClass: "gfu-modal__header",
                            attrs: { "data-qa": "box:Title" },
                          },
                          [
                            _vm.title
                              ? _c(
                                  "h1",
                                  {
                                    staticClass:
                                      "gfu-heading _flex _gap-2 _ai-c",
                                  },
                                  [
                                    _vm.icon !== null
                                      ? _c("base-icon", {
                                          staticClass: "_tc--accent",
                                          attrs: {
                                            name: _vm.icon,
                                            "icon-namespace": _vm.iconNamespace,
                                            size: "lg",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(_vm.title))]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$slots["notificators"]
                              ? _c(
                                  "div",
                                  { staticClass: "_flexcol _gap-2 _my-3" },
                                  [_vm._t("notificators")],
                                  2
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.subtitle
                              ? _c("div", { staticClass: "gfu-subheading" }, [
                                  _vm._v(_vm._s(_vm.subtitle)),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { class: ["gfu-modal__content", _vm.contentClasses] },
                      [_vm._t("default")],
                      2
                    ),
                    _vm._v(" "),
                    _vm.$slots["actions"]
                      ? _c(
                          "div",
                          { staticClass: "gfu-form__footer _mt-0" },
                          [_vm._t("actions")],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("progress-overlay", {
                      staticClass: "gfu-progress-overlay--modal",
                      attrs: {
                        visible: _vm.isProcessing || _vm.isModalProcessing,
                        message: _vm.processingMessage,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }